export const UUID_REGEX_STRING: string =
  '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}';
export const GLOBAL_UUID_REGEX: RegExp = new RegExp(UUID_REGEX_STRING, 'g');
